import styled from 'styled-components';
import Icon from '../../../atoms/Icon';

const DropdownArrowIcon = styled(Icon)`
  height: 15px;
  width: 13px;
  transform: ${(props) => (props.active ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;

/**
 * @param {DropdownTogglerProps} props
 * @returns {React.ReactElement} The rendered component
 */
const DropdownToggler = ({ active }) => {
  return <DropdownArrowIcon icon="ARROW_BOLD" active={active} />;
};

export default DropdownToggler;
